export default {"src":"/_next/static/media/main.a5078fc2.svg","height":190,"width":177,"blurWidth":0,"blurHeight":0};